import React,{useState} from "react";
import {Link, Grid, Hidden, Typography, Container, 
	TextField, CssBaseline, Button, CircularProgress} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import { useImmer } from "use-immer";
import {post} from "api";
import loader from "api/loader";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));

export default function SignIn() {
	const classes = useStyles();
	let history = useHistory();
	const [user, setUser] = useImmer({clave:"",correo:"",password:""});
	const [status, setStatus] = useState({status:"ready"});

	const handleLogin = (e) => {
		e.preventDefault();
		setStatus({status:"loading"});
		post("superadmin-login",user).then(r=>{
			loader.login(r.data.token);
			history.replace("/cursos");
		}).catch(e=>{
			console.log(e);
			setStatus({status:"error",message:e});
		});
		console.log(user);
	};
	return (
		<Grid container spacing={0}>
        
			{/* <Hidden smDown>
				<Grid item xs>
					<img src={require("assets/img/login.png")}
						alt="imagen principal"
						style={{ width: "100%",
							height: "100vh",
							objectFit: "cover"}}
					/>
				</Grid>
			</Hidden> */}
			<Grid item sm={12}>
				<Container component="main" maxWidth="xs">
					<CssBaseline />
					<div className={classes.paper}>
						<img src={require("assets/img/logo/logo_nombre.png")}
							alt="imagen principal"
							style={{ 
								height: "130px",
								marginBottom:"30px",
								objectFit: "cover"}}
						/>
						<Typography color="primary" component="h1" variant="h5">
							INGRESA TUS DATOS DE ACCESO
						</Typography>
						
						<form className={classes.form} noValidate>
							
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								id="email"
								label="Correo"
								name="email"
								autoComplete="email"
								value={user.correo}
								onChange={(e)=>{
									e.persist();
									setUser((draft)=>{draft.correo = e.target.value;});
								}}
							/>
							<TextField
								variant="outlined"
								margin="normal"
								required
								fullWidth
								name="password"
								label="Contraseña"
								type="password"
								id="password"
								autoComplete="current-password"
								value={user.password}
								onChange={(e)=>{
									e.persist();

									let value = e.target.value;
									setUser((draft)=>{draft.password = value;});
								}}
							/>
							{status.status==="error" &&
                  <Alert severity="error">{JSON.stringify(status.message)}</Alert>
							}
							{status.status==="loading" ?
								<CircularProgress />
								:
								<Button
									type="submit"
									fullWidth
									variant="contained"
									color="primary"
									onClick={handleLogin}
								>
                    Iniciar sesión
								</Button>
							}
                
                
							<Grid style={{marginTop:"17px"}} container>
								<Grid item xs>
									<Link href="/forgot" variant="body2">
                     ¿Olvidaste tu contraseña?
									</Link>
								</Grid>
								{/* <Grid item>
									<Link href="/registro" variant="body2">
										{"¿No tienes cuenta? Registrate"}
									</Link>
								</Grid> */}
							</Grid>
						</form>
					</div>
				</Container>
			</Grid>
		</Grid>
     
    
	);
}